
/**
 * MessageConstants
 * エラーメッセージ定義
 */
export class MessageConstants {

	public static readonly message = {
		// 診察券番号（カルテ番号）
		MESSAGE_MEDICAL_RECORD_MEDICAL_RECORD_NUMBER: '診察券番号を入力してください。',
		MESSAGE_MEDICAL_RECORD_MEDICAL_RECORD_NUMBER_NOT_MATCH_PATTERN: '診察券番号には7桁または8桁の数字を入力してください。',

		// 姓
		MESSAGE_USER_LASTNAME_NO_INPUT: '姓を入力してください。',
		MESSAGE_USER_LASTNAME_NOT_MATCH_PATTERN: '姓の形式が違います。',

		// 姓（カナ）
		MESSAGE_USER_LASTNAME_KANA_NO_INPUT: '姓（カナ）を入力してください。',
		MESSAGE_USER_LASTNAME_KANA_NOT_MATCH_PATTERN: '姓（カナ）の形式が違います。全角カタカナで入力してください。',

		// 名
		MESSAGE_USER_FIRSTNAME_NO_INPUT: '名を入力してください。',
		MESSAGE_USER_FIRSTNAME_NOT_MATCH_PATTERN: '名の形式が違います。',

		// 名（カナ）
		MESSAGE_USER_FIRSTNAME_KANA_NO_INPUT: '名（カナ）を入力してください。',
		MESSAGE_USER_FIRSTNAME_KANA_NOT_MATCH_PATTERN: '名（カナ）の形式が違います。全角カタカナで入力してください。',

		// ミドルネーム
		MESSAGE_USER_MIDDLENAME_NOT_MATCH_PATTERN: 'ミドルネームの形式が違います。',

		// 性別
		MESSAGE_USER_GENDER_NOT_SELECT: '性別を選択してください。',

		// 電話番号
		MESSAGE_USER_TELL_NO_INPUT: '電話番号を入力してください。',
		MESSAGE_USER_TELL_NOT_MATCH_PATTERN: '電話番号の形式が違います。ハイフン無しの半角数字で入力してください。',

		// 電話機の種類
		MESSAGE_USER_DEVICE_TYPE_NO_SELECT: '電話機の種類を選択してください。',

		// 住所
		MESSAGE_USER_POST_CODE_NO_INPUT: '郵便番号を入力してください。',
		MESSAGE_USER_POST_CODE_NOT_MATCH_PATTERN: '郵便番号の形式が違います。ハイフン無しの半角数字7桁で入力してください。',
		MESSAGE_USER_PREFECTURE_NO_INPUT: '都道府県を入力してください。',
		MESSAGE_USER_PREFECTURE_NOT_MATCH_PATTERN: '都道府県の形式が異なります。',
		MESSAGE_USER_CITY_NO_INPUT: '市区町村を入力してください。',
		MESSAGE_USER_CITY_NOT_MATCH_PATTERN: '市区町村の形式が異なります。',
		MESSAGE_USER_ADDRESS_NO_INPUT: '番地を入力してください。',
		MESSAGE_USER_ADDRESS_NOT_MATCH_PATTERN: '番地の形式が異なります。',
		MESSAGE_USER_BUILDING_NOT_MATCH_PATTERN: '建物名・部屋番号の形式が違います。',
		MESSAGE_USER_TO_NAME_NOT_MATCH_PATTERN: '宛先名の形式が違います。',

		// 生年月日
		MESSAGE_USER_BIRTHDAY_NO_INPUT: '生年月日を入力してください。',

		// メールアドレス
		MESSAGE_USER_EMAIL_NO_INPUT: 'メールアドレスを入力してください。',
		MESSAGE_USER_EMAIL_NOT_MATCH_PATTERN: 'メールアドレスの形式が違います。',

		// パスワード
		MESSAGE_USER_PASSWORD_NO_INPUT: 'パスワードを入力してください。',
		MESSAGE_USER_PASSWORD_NOT_MATCH_PATTERN: 'パスワードの形式が違います。半角英数記号8文字以上で入力してください。',
	};
}
